import KiccEasyCardApi from '@apis/easyCard/KiccEasyCardApi';
import useLoading from '@hooks/ui/useLoading';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useRegisterKiccEasyCard() {
    const { t } = useTranslation('easyCard');
    const { startLoading, stopLoading } = useLoading();
    const { mutate } = useMutation({
        mutationFn: KiccEasyCardApi.registerCard,
        onMutate() {
            startLoading();
        },
        onSuccess(data) {
            const { authPageUrl } = data;
            window.location.href = authPageUrl;
        },
        onSettled() {
            stopLoading();
        },
        onError(e) {
            console.error(e);
            toast.error(t('register.error'));
        },
    });

    const handleRegisterCard = () => {
        mutate({});
    };

    return {
        handleRegisterCard,
    };
}

export default useRegisterKiccEasyCard;
